import { Box, CircularProgress } from '@chakra-ui/react';
import { TCartFunnul } from '@containers/checkout';
import CartContainer from '@containers/checkout/cart';
import PaymentContainer from '@containers/checkout/payment';
import { Suspense } from 'react';

type TOrderContainerProps = {
  funnel: TCartFunnul;
  setFunnel: (step: TCartFunnul) => any;
  goToNext: () => void;
};

export default function OrderContainer({
  funnel,
  setFunnel,
  goToNext,
}: TOrderContainerProps) {
  return (
    <>
      {funnel === 'cart' && (
        <div>
          <Suspense>
            <CartContainer
              next={() => {
                setFunnel('payment');
                goToNext();
              }}
            />
          </Suspense>
        </div>
      )}
      {funnel === 'payment' && (
        <Suspense
          fallback={
            <Box
              display="flex"
              position="fixed"
              alignItems="center"
              justifyContent="center"
              top="0"
              left="0"
              width="100vw"
              height="100vh"
              zIndex="9999"
              background="rgba(0, 0, 0, 0.2)"
            >
              <CircularProgress
                isIndeterminate
                color="#000"
                trackColor="transparent"
                thickness="4px"
              />
            </Box>
          }
        >
          <PaymentContainer />
        </Suspense>
      )}
    </>
  );
}
